import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getChats } from 'service/ChatService'
import { setMessageChat } from 'store/slices/ChatSlice'
import { setAlertById, setAlertMessagesById } from 'store/slices/AlertSlice'
import useAuthenticatedSocket from 'hooks/useAuthenticatedSocket'
import HandleWsNotifications from './HandleWsNotifications/HandleWsNotifications'
import HandleWsChat from './HandleWsChat/HandleWsChat'

const WsNotifications = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const userId = useSelector(state => state.auth?.me?.id)
  const allChats = useSelector(state => state.chat.messagechat)
  useAuthenticatedSocket('/ws/online_status/', { enabled: Boolean(userId) })
  useEffect(() => {
    let active = true
    if (!userId) { dispatch(setMessageChat({ messagechat: [] })); dispatch(setAlertById({ alerts: [] })); dispatch(setAlertMessagesById({ alertsMessages: [] })); return undefined }
    getChats().then(({ data }) => { if (active) dispatch(setMessageChat({ messagechat: Array.isArray(data) ? data : data.results || [] })) }).catch(() => {})
    return () => { active = false }
  }, [userId, dispatch])
  if (!userId) return null
  return <><HandleWsNotifications user_id={userId} />{!location.pathname.startsWith('/chats') && Array.isArray(allChats) && allChats.filter(item => item?.id).map(item => <HandleWsChat key={`${userId}-${item.id}`} chatId={item.id} user_id={userId} />)}</>
}
export default WsNotifications
